import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class ClassificationActions extends Actions{
    static get target(){
        return 'classifications'
    }
}


// WEBPACK FOOTER //
// ./actions/ClassificationActions.js